;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	Backbone.Form.editors.LeagueImagePicker = Backbone.Form.editors.Base.extend({
		className: 'league-image-uploader imageUploader',
		
		initialize: function(options) {
			Backbone.Form.editors.Base.prototype.initialize.call(this, options);
			var avatar_url = '',
				schema_options = options.schema.options;

			const accepted_image_formats = ['image/x-png','image/gif','image/jpeg'];


			if(options.model.get('id')){
				avatar_url = this.getUploadedAvatarUrl(options.model, schema_options);
			}else {
				avatar_url = schema_options.default_img_url;
			}
			
			this.offEvents();

			this.img_url = schema_options.img_url;
			this.button_text  = schema_options.button_text ? schema_options.button_text : 'Upload';
			this.$input = $('<input type="hidden" name="'+this.key+'" />');
			this.$uploadInput = $('<input type="file" style="display: none" accept="'+accepted_image_formats+'" />');
			this.$image = $('<img id="uploaded-image" src="'+avatar_url+'" alt="your avatar">');
			this.$button = $('<p class="upload-img-button league btn">'+this.button_text+'</p>');
			
			this.setListenersOnce = _.once(this.setClickListeners)
		},
		
		offEvents() {
			
			$(document).off('change', 'input[type=file]');
			$(document).off('click', '.remove');
			$(document).off('click', '.upload-img-button');
			$(document).off('click', '#uploaded-image');
			
			return this;
		},
		
		setClickListeners() {
			
			$(document).on('change', 'input[type=file]',  _.bind(this.uploadFile, this));
			$(document).on('click', '.remove',            _.bind(this.removeFile, this));
			$(document).on('click', `#uploaded-image`, _.bind(this.fireUploadInput, this));
			$(document).on('click', `.upload-img-button`,   _.bind(this.fireUploadInput, this));
			
			return this;
		},
		
		getValue: function(value) {
			var val = this.value;
			return val ? val : '';
		},
		setValue: function(value) {
			this.value = value;
			this.model.set('league_avatar', value);
		},
		render: function(options) {
			
			//this.$el.parent().eq(1).css('display', 'none')

			this.$el.append(this.$image);
			this.$el.append(this.$button);
			this.$el.append(this.$input);
			this.$el.append(this.$uploadInput);
	
			Backbone.Form.editors.Base.prototype.render.apply(this, arguments);
			this.setListenersOnce();
			return this;
		},
		uploadFile: function(e) {
			var _this = this;
			var file = this.$uploadInput.get(0).files[0];

			this.setValue(file);
			this.readURL(this.$uploadInput.get(0));
			this.trigger('change', this);

			return this;
		},
		removeFile: function(ev) {
			if (ev) ev.preventDefault();
			var url = $(ev.currentTarget).data('url');
			var files = this.getValue();
			this.setValue(_(files).reject(function(one) {
				return one.url === url;
			}));
		},
		readURL: function(input) {
			var _this = this;
			if (input.files && input.files[0]) {
				var reader = new FileReader();
				reader.onload = function (e) {
					_this.$image.attr('src', e.target.result);
				};
				reader.readAsDataURL(input.files[0]);
			}
		},
		fireUploadInput: function(){
			this.$uploadInput.click();
		},
		getUploadedAvatarUrl: function(league_model, schema_options){

			var avatar_version = league_model.get('avatar_version');
			if(!avatar_version){
				return schema_options.default_img_url;
			}

			return CONFIG.LEAGUE_AVATAR_URL + league_model.get('id') + '.png?' + avatar_version;
		}
	});


}(window, APP, Backbone, Marionette, $, _));